import * as React from 'react';
import Page from '../components/Page';
import Section from '../components/Section';

export default function SignUpToContractPage() {
  return (
    <Page
      title="Begin selling through Filtru"
      subtitle="Get your coffee in front of Filtru users"
    >
      <Section title="Basic Details">
        Please contact support team to discuss this futher{' '}
        <a className="link gold b dim" href="mailto:support@filtru.coffee">
          support@filtru.coffee
        </a>
      </Section>
    </Page>
  );
}
